import { createContext } from 'react';
export const RadioContext = createContext({
    selectedValue: undefined,
    itemClassName: '',
    hideRadio: false,
});
//# sourceMappingURL=radio.context.js.map